import * as actionTypes from '../constants/actionTypes';
export function hideOpenInMobile() {
    return {
        type: actionTypes.HIDE_OPEN_IN_MOBILE,
    };
}
